import { render } from "./EmergenciasMedicas.vue?vue&type=template&id=e8f0c8e6&scoped=true"
import script from "./EmergenciasMedicas.vue?vue&type=script&lang=js"
export * from "./EmergenciasMedicas.vue?vue&type=script&lang=js"

import "./EmergenciasMedicas.vue?vue&type=style&index=0&id=e8f0c8e6&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f0c8e6"]])

export default __exports__